// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_CMY","cls2":"AvatarCell-cls2_0lY AvatarCell-cls1_CMY","size-lg":"AvatarCell-size-lg_2i7","size-md":"AvatarCell-size-md_uq9"};